import type { ConceptDef } from '../types';

export const simpleSubtraction: ConceptDef = {
  kind: 'tileMatch',
  id: 'simple-subtraction',
  label: 'Simple Subtraction',
  category: 'Math',
  description: 'Hear a simple subtraction; tap the answer.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Three minus one.', answer: '2' },
      { say: 'Four minus one.', answer: '3' },
      { say: 'Five minus one.', answer: '4' },
      { say: 'Six minus one.', answer: '5' },
      { say: 'Seven minus one.', answer: '6' },
      { say: 'Eight minus one.', answer: '7' },
    ],
  },
};
